import { cx } from '@emotion/css';

import messages from './messages.json';
import {
  fontSmallClassName,
  footerRightClassName,
  footerTextClassName,
  footerTextLabelClassName,
  footerTextValueClassName,
  italicTextClassName,
} from './styles';

interface Props {
  sender: string;
  fontSmall?: boolean;
}

const CardHeroSender = ({ sender, fontSmall }: Props) => {
  return (
    <h6
      className={cx(footerTextClassName, footerRightClassName, {
        [fontSmallClassName]: fontSmall,
      })}
    >
      <span className={cx(footerTextLabelClassName, italicTextClassName)}>
        {messages.senderFromLabel}
      </span>
      <span className={footerTextValueClassName}>{sender}</span>
    </h6>
  );
};

CardHeroSender.displayName = 'CardHeroSender';

export default CardHeroSender;
